import access from '../mixin/access'

export default {
  mixins: {access},
  data: () => ({
    tooltip_entity: ''
  }),
  mounted () {
    if (this.tooltip_entity === '') {
      this.tooltip_entity = this.entity
    }
  },
  computed: {
    editTooltipText () {
      return this.checkPermission(this.tooltip_entity, 'edit') ? 'Editar' : 'Sem permissão para editar'
    },
    deleteTooltipText () {
      return this.checkPermission(this.tooltip_entity, 'delete') ? 'Excluir' : 'Sem permissão para excluir'
    },
    manageTooltipText () {
      return this.checkPermission(this.tooltip_entity, 'manage') ? 'Gerenciar' : 'Sem permissão para gerenciar'
    },
    createTooltipText () {
      return this.checkPermission(this.tooltip_entity, 'create') ? 'Adicionar' : 'Sem permissão para adicionar'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/tooltip.js